import React, { memo } from "react";

import CompositeMetric from "@/components/molecules/CompositeMetric";
import { Box } from "@/components/atoms/Box";
import { Pressable } from "@/components/atoms/Pressable";
import { ICompositeMetric } from "@/stores/compositeMetric";

/**
 * Props for MetricItemView component
 */
interface MetricItemViewProps {
  compositeMetric: ICompositeMetric;
  numCols: number;
  isSmallScreen: boolean;
  isDark: boolean;
  isInteractive: boolean;
  onPress: () => void;
}

/**
 * Presentation component for a single metric item in the player detail grid
 * @param root0 - Component props
 * @param root0.compositeMetric - The composite metric to display
 * @param root0.numCols - Number of columns for grid layout
 * @param root0.isSmallScreen - Whether rendering on mobile screen size
 * @param root0.isDark - Whether using dark theme styling
 * @param root0.isInteractive - Whether the metric is interactive/clickable
 * @param root0.onPress - Callback invoked when the metric is pressed
 */
const MetricItemView = ({
  compositeMetric,
  numCols,
  isSmallScreen,
  isDark,
  isInteractive,
  onPress,
}: MetricItemViewProps) => (
  <Box
    key={compositeMetric.label}
    className={`${numCols === 3 ? "w-1/3" : "w-1/2"} shrink-0 grow-0 ${isInteractive ? "web:cursor-pointer" : "web:cursor-default"}`}
  >
    <Pressable className="flex-1" onPress={onPress}>
      <CompositeMetric
        label={compositeMetric.label}
        formattedValue={compositeMetric.formattedValue}
        styles={compositeMetric.styles}
        isSmallScreen={isSmallScreen}
        isDark={isDark}
      />
    </Pressable>
  </Box>
);

MetricItemView.displayName = "MetricItemView";

export default memo(MetricItemView);
